var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "book") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.766 18.75h16.984v-18h-17.031c-1.568 0.005-2.839 1.275-2.844 2.843v16.575h0.001c-0 0.007-0.001 0.014-0.001 0.021 0 1.659 1.302 3.061 2.844 3.061h17.031v-1.5h-17.031c-0.703 0-1.344-0.744-1.344-1.561 0-0.78 0.637-1.439 1.391-1.439zM16.875 2.266v8.101l-2.269-1.992-2.231 1.98v-8.089zM10.875 2.25v10.125h1.483l2.254-2 2.278 2h1.486v-10.125h1.875v15h-13.871l-0.004-15zM4.719 2.25h0.156l0.004 15h-0.113c-0.512 0-0.991 0.137-1.404 0.377l0.013-0.007v-14.014c0-0.001 0-0.003 0-0.004 0-0.744 0.601-1.347 1.343-1.351h0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.fd07bd9be86fdb57f8850a2588b68fd5.svg";
export { ForwardRef as ReactComponent };